/**
 * Utilitário para acessar URLs da API
 */

/**
 * Retorna a URL base da API a partir da variável de ambiente
 * @returns {string} URL base da API
 */
export const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_URL || 'https://api.atlasplugins.com';
};

/**
 * Constrói uma URL para a versão específica da API
 * @param {string} version - Versão da API (v1, v2, etc.)
 * @returns {string} URL base da versão da API
 */
export const getApiVersionUrl = (version) => {
  return `${getApiBaseUrl()}/${version}`;
};

/**
 * Constrói uma URL completa para a API
 * @param {string} version - Versão da API (v1, v2, etc.)
 * @param {string} path - Caminho adicional da URL, sem a barra inicial
 * @returns {string} URL completa da API
 */
export const getApiUrl = (version, path) => {
  return `${getApiVersionUrl(version)}/${path}`;
};

/**
 * Constrói uma URL para download de arquivos da API v1
 * @param {string} fileId - ID do arquivo
 * @returns {string} URL para download do arquivo
 */
export const getFileDownloadUrl = (fileId) => {
  return getApiUrl('v1', `file/download/${fileId}`);
};

/**
 * Constrói uma URL para exibição de imagens da API v1
 * @param {string} imageId - ID da imagem
 * @returns {string} URL para exibição da imagem
 */
export const getImageUrl = (imageId) => {
  return getApiUrl('v1', `file/image/${imageId}`);
};

/**
 * Constrói uma URL para download de plugins
 * @param {string} pluginId - ID do plugin
 * @returns {string} URL para download do plugin
 */
export const getPluginDownloadUrl = (pluginId) => {
  return getApiUrl('v1', `plugin/${pluginId}/download`);
};

/**
 * Constrói uma URL para a API de plugins
 * @param {string} pluginId - ID do plugin
 * @returns {string} URL para a API do plugin
 */
export const getPluginApiUrl = (pluginId) => {
  return getApiUrl('v1', `plugin/${pluginId}/api`);
};

/**
 * Constrói uma URL para a nuvem de plugins
 * @param {string} pluginId - ID do plugin
 * @returns {string} URL para a nuvem do plugin
 */
export const getPluginCloudUrl = (pluginId) => {
  return getApiUrl('v1', `plugin/${pluginId}/cloud`);
};

/**
 * Constrói uma URL para licenças de plugins
 * @returns {string} URL para licenças de plugins
 */
export const getPluginLicenseUrl = () => {
  return getApiUrl('v1', 'plugin/license');
};

/**
 * Constrói uma URL para upload de arquivos de ticket de suporte
 * @param {string} ticketId - ID do ticket
 * @returns {string} URL para upload de arquivos de ticket
 */
export const getTicketFileUploadUrl = (ticketId) => {
  return getApiUrl('v1', `ticket/${ticketId}/files`);
};

/**
 * Constrói uma URL para upload de imagem do servidor
 * @returns {string} URL para upload de imagem do servidor
 */
export const getServerImageUploadUrl = () => {
  return getApiUrl('v1', 'user/server/image');
}; 